import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.FirstStartModule.account', {
    companyCount1: '1',
    companyCount2_5: '2 - 5',
    companyCount6_10: '6 - 10',
    companyCount11: '11+',
});
